@if (router.url != '/') {
  <div fxLayout="row wrap">
    <div fxFlex="100" class="p-1">
      <mat-card appearance="outlined" fxLayout="row" class="breadcrumb no-box-shadow no-padding">
        @if (router.url != '/') {
          <a routerLink="/" class="breadcrumb-item" fxLayout="row" fxLayoutAlign="start center" (click)="refreshPage()">
            <mat-icon>group_add</mat-icon>
            <span class="breadcrumb-title">New PTM</span>
          </a>
        }
        @for (breadcrumb of breadcrumbs; track breadcrumb; let i = $index) {
          <div class="breadcrumb-item" fxLayout="row" fxLayoutAlign="start center">
            <!-- Query params options: https://stackoverflow.com/a/47366232/9128896 -->
            <a [hidden]="i == (breadcrumbs.length - 1)" [routerLink]="[breadcrumb.url]" queryParamsHandling="preserve">{{breadcrumb.name}}</a>
            <span [hidden]="i != (breadcrumbs.length - 1)" class="breadcrumb-title active">{{breadcrumb.name}}</span>
          </div>
        }
      </mat-card>
    </div>
  </div>
}
